/**
 * Carbon form components accept string | number for value/defaultValue,
 * but InputHTMLAttributes/TextareaHTMLAttributes allow readonly string[] (for file inputs).
 * This helper narrows the type for compatibility.
 */
export const narrowToStringOrNumber = (
  v: string | number | readonly string[] | undefined
): string | number | undefined =>
  typeof v === 'string' || typeof v === 'number' ? v : undefined
